import { Box } from '@lifechurch/react-ion';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ServiceDataMoment } from '../AnalyticsServiceGrid';
import { TableRow } from './TableRow';

interface Props {
  moments: ServiceDataMoment[];
}

const StyledTableBody = styled(Box)`
  background-color: white;

  > div {
    border-radius: 2px;
  }

  div:nth-child(odd) {
    background-color: ${props => props.theme.colors.gray5};
  }
`;

const TableBody: FC<Props> = ({ moments }) => {
  return (
    <StyledTableBody>
      {moments.map(moment => (
        <TableRow key={moment.id} moment={moment} />
      ))}
    </StyledTableBody>
  );
};

export { TableBody };
